import { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { RegistrationContext } from '../../../context/registration';
import { useToasts } from 'react-toast-notifications';
import { otherTypeCodes } from '../../../shared/config';

import {
  setInjuryTimeFrame,
  fetchCampaignContext,
} from '~/services/registration';
import { fetchInjuryTimeFrames } from '~/services/options';

import { ProgressBar } from '../ProgressBar';
import {
  Container,
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Form,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';

import { SelectOption } from '~/types/globals';
import { Loading } from '../../../shared/components/Loading';
import { CampaignType } from '~/types/campaign';

export const When = ({}: any) => {
  const [{ campaign, campaignRequest }, registrationDispatch] =
    useContext(RegistrationContext);
  const [campaignType, setCampaignType] = useState<CampaignType>();
  const [timeFrameOptions, setTimeFrameOptions] = useState<SelectOption[]>([]);
  const [selectedOption, setSelectedOption] = useState<SelectOption>();
  const [showDate, setShowDate] = useState<boolean>(false);
  const [injuryDate, setInjuryDate] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const { addToast } = useToasts();
  const history = useHistory();

  const getTimeFrameOptions = async () => {
    const resp = await fetchInjuryTimeFrames();
    console.log('campaignType: ', campaignType);
    if (!campaignType) {
      console.log('NO campaignType: ', campaignType);

      return;
    }

    let opts;
    if (campaignType.code === 'transplant') {
      // Filter on medical_reason === 1
      opts = resp
        .filter((x) => x.medical_reason === 1)
        .map((x) => {
          return {
            label: x.name,
            value: x.code,
          };
        });
    } else if (campaignType.code === 'cat_injury') {
      opts = resp
        .filter((x) => x.medical_reason === 2)
        .map((x) => {
          return {
            label: x.name,
            value: x.code,
          };
        });
    } else if (campaignType.code === 'cat_illness') {
      opts = resp
        .filter((x) => x.medical_reason === 3)
        .map((x) => {
          return {
            label: x.name,
            value: x.code,
          };
        });
    }
    setTimeFrameOptions(opts);
    console.log('opts: ', opts);
    setLoading(false);
  };

  const getCampaign = async () => {
    const resp = await fetchCampaignContext();
    console.log('resp: ', resp);

    registrationDispatch({
      type: 'set_registration',
      payload: resp,
    });
  };

  useEffect(() => {
    if (campaign) {
      setCampaignType(campaign.campaign_type);
    } else {
      getCampaign();
    }
  }, [campaign]);

  useEffect(() => {
    if (campaignType) {
      getTimeFrameOptions();
    }
  }, [campaignType]);

  useEffect(() => {
    if (selectedOption && selectedOption.value != 'pre') {
      console.log('set show date');
      setShowDate(true);
    }
  }, [selectedOption]);

  const handleNext = async () => {
    if (!selectedOption) {
      return;
    }
    console.log('injuryDate: ', injuryDate);
    try {
      setSaving(true);
      const resp = await setInjuryTimeFrame(selectedOption.value, injuryDate);

      console.log('resp: ', resp);
      registrationDispatch({
        type: 'set_patient',
        patient: resp,
      });

      const isOther = otherTypeCodes.includes(
        campaignRequest.campaign_is_for?.code
      );
      if (isOther) {
        history.push('/get-started/financials/insurance');
      } else {
        history.push('/get-started/condition/medical-professional');
      }
    } catch (e) {
      console.log('e: ', e);
    }
  };

  if (loading || !timeFrameOptions) {
    console.log('timeFrameOptions: ', timeFrameOptions);
    return <Loading />;
  }

  const isValid = selectedOption;

  console.log('showDate: ', showDate);

  return (
    <Container>
      <ProgressBar selectedStep='patient' />

      <Form>
        <Row className='justify-content-center py-5'>
          <Col md='6'>
            <div className='text-center'>
              <h3>And when did this {campaignType?.name} happen?</h3>
            </div>

            <Card
              className='box-shadow my-5'
              style={{
                maxWidth: '400px',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <CardBody>
                <FormGroup check className='mb-3'>
                  {timeFrameOptions?.map((opt, i) => {
                    return (
                      <div key={i}>
                        <Label check>
                          <Input
                            type='radio'
                            value={opt.value}
                            onClick={() => setSelectedOption(opt)}
                            name='injury_time_frame'
                          />
                          {opt.label}
                        </Label>
                      </div>
                    );
                  })}
                  {showDate && (
                    <div className='flex'>
                      It happened on
                      <Input
                        type='date'
                        name='injury_date'
                        onChange={(e) => setInjuryDate(e.target.value)}
                      />
                    </div>
                  )}
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <div className='text-center mb-5'>
          <Button
            color='outline-dark'
            disabled={saving}
            onClick={() => history.push('/get-started/condition/type')}
          >
            Back
          </Button>
          <Button
            color='primary'
            disabled={!isValid || saving}
            onClick={handleNext}
          >
            {saving ? `Saving` : `Next`}
          </Button>
        </div>
      </Form>
    </Container>
  );
};
